<div class="detail-crypto-card">
  <div class="close" (click)="closeExchangeForm(); $event.stopPropagation()">
    <img src="assets/icons/news/close.svg" alt="close modal" />
  </div>
  <div class="left">
    <div class="card-header">
      <div class="coin-container">
        <img [src]="'/assets/icons/crypto/' + cryptoSymbol.toLowerCase() + '.svg'" alt="" />
        <p class="coin-label">{{ cryptoSymbol }}</p>
      </div>
      <div class="crypto-price" *ngIf="isMobile">
        <div class="contain-price">
          <p *ngIf="isArsCurrency && !loading" class="price">
            {{ (isBuying ? getCryptoPrice(0) : getCryptoPrice(1)) | currencyArs }}
          </p>
          <p *ngIf="!isArsCurrency && !loading" class="price">
            U$D {{ (isBuying ? getCryptoPrice(0) : getCryptoPrice(1)) | number : '0.3-3' }}
          </p>
        </div>

        <p
          class="dailyChange"
          [class.green]="variation > 0"
          [class.red]="variation < 0"
          *ngIf="(variation < 0 || variation === 0 || variation > 0) && cryptoSymbol !== 'USDT'"
        >
          {{ variation > 0 ? '+' : '' }}{{ variation | number : '.0-3' }}%
        </p>
      </div>
      <div *ngIf="isMobile">
        <button (click)="isViewChartMobile()">
          <svg
            *ngIf="!viewChartMobile"
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="14" cy="14" r="13" fill="#1F1D2C" stroke="#EEF0F5" stroke-width="2" />
            <circle cx="13.9993" cy="8.16732" r="2.33333" fill="#EEF0F5" />
            <rect x="12.834" y="12.834" width="2.33333" height="7" rx="1.16667" fill="#EEF0F5" />
            <rect
              x="15.166"
              y="12.834"
              width="2.33333"
              height="4.66667"
              rx="1.16667"
              transform="rotate(90 15.166 12.834)"
              fill="#EEF0F5"
            />
            <rect
              x="17.5"
              y="18.6674"
              width="2.33333"
              height="7"
              rx="1.16667"
              transform="rotate(90 17.5 18.6674)"
              fill="#EEF0F5"
            />
          </svg>
          <svg
            *ngIf="viewChartMobile"
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="14" cy="14" r="13" fill="#1F1D2C" stroke="#6B5ECD" stroke-width="2" />
            <circle cx="13.9993" cy="8.16732" r="2.33333" fill="#6B5ECD" />
            <rect x="12.834" y="12.834" width="2.33333" height="7" rx="1.16667" fill="#6B5ECD" />
            <rect
              x="15.166"
              y="12.834"
              width="2.33333"
              height="4.66667"
              rx="1.16667"
              transform="rotate(90 15.166 12.834)"
              fill="#6B5ECD"
            />
            <rect
              x="17.5"
              y="18.6674"
              width="2.33333"
              height="7"
              rx="1.16667"
              transform="rotate(90 17.5 18.6674)"
              fill="#6B5ECD"
            />
          </svg>
        </button>
      </div>
    </div>
    <div
      class="period-selector"
      [style]="isStable && !isMobile ? 'right: 125px' : !isMobile ? 'right: 110px' : ''"
      [ngClass]="{
        'view-chart-mobile': viewChartMobile
      }"
    >
      <div class="buttons-container">
        <ng-container *ngIf="!isStable">
          <button
            (click)="getDataForVolatilChart('hour', '672', 'hour')"
            [class.selected]="selectedPeriod === 'hour'"
          >
            1H
          </button>
          <button
            (click)="getDataForVolatilChart('day', '365', 'day')"
            [class.selected]="selectedPeriod === 'day'"
          >
            1D
          </button>
        </ng-container>
        <ng-container *ngIf="isStable">
          <button (click)="updatePeriodChart('hour')" [class.selected]="selectedPeriod === 'hour'">
            1H
          </button>
          <button (click)="updatePeriodChart('day')" [class.selected]="selectedPeriod === 'day'">
            1D
          </button>
        </ng-container>
      </div>
    </div>
    <div
      class="chart-container"
      [ngClass]="{
        'view-chart-mobile': viewChartMobile
      }"
    >
      <div class="chart-light-weight" #chartLightWeight></div>
      <div class="loading center-loading" *ngIf="isLoadingChart">
        <div class="circle-loader"></div>
      </div>
      <span class="tooltip" #tooltip [style]="coordinate" *ngIf="!hiddenTooltip">
        {{
          isStable
            ? (tooltipInfo?.value | number : '0.3-3')
            : (tooltipInfo?.close | number : '0.3-3')
        }}
      </span>
    </div>
    <div
      class="coin-description"
      [ngClass]="{
        'view-chart-mobile': viewChartMobile
      }"
    >
      <p class="description">{{ coinBasicInfo?.description }}</p>
      <div class="contain">
        <div>
          <p class="title">Ranking (Market Cap.)</p>
          <p class="information">
            {{ assetsCoinCapApi?.rank ? '#' + assetsCoinCapApi?.rank : labelRank }}
          </p>
        </div>
        <div>
          <p class="title">Creado por</p>
          <p class="information">{{ coinBasicInfo.creator }}</p>
        </div>
        <div>
          <p class="title">Categoría</p>
          <p class="information">{{ coinBasicInfo.category }}</p>
        </div>
        <div>
          <p class="title">Redes de retiro</p>
          <p class="information">{{ labelNetworks ? labelNetworks : '-' }}</p>
        </div>
        <div>
          <p class="title">Volumen 24hs</p>
          <p class="information">{{ assetsCoinCapApi?.volumeUsd24Hr | volumeDay }}</p>
        </div>
        <div>
          <p class="title">Website</p>
          <p class="information pointer" (click)="openOficialCoinPage()">
            {{ coinBasicInfo.detailUrl }}
          </p>
        </div>
      </div>
      <!-- <p class="bold" (click)="openOficialCoinPage()">Conocer más</p> -->
      <p class="warning" *ngIf="cryptoSymbol === 'BTC'">
        Depósitos y retiros únicamente por la BSC.
      </p>
      <!-- <button class="td-btn more-info-btn">Más información</button> -->
    </div>
  </div>
  <div
    class="exchange-form-section"
    [ngClass]="{
      'hidden-mobile': viewChartMobile
    }"
  >
    <div class="choice">
      <div class="circle" [class.isBuying]="isBuying"></div>
      <div class="pill" [ngClass]="{ active: isBuying }" (click)="toggleOperationType('buy')">
        <p [ngClass]="{ active: isBuying }">Comprar</p>
      </div>
      <div class="pill" [ngClass]="{ active: !isBuying }" (click)="toggleOperationType('sell')">
        <p [ngClass]="{ active: !isBuying }">Vender</p>
      </div>
    </div>
    <div class="crypto-price" *ngIf="!isMobile">
      <div class="contain-price">
        <p class="lead-price">Precio</p>
        <p *ngIf="isArsCurrency && !loading" class="price">
          {{ (isBuying ? getCryptoPrice(0) : getCryptoPrice(1)) | currencyArs }}
        </p>
        <p *ngIf="!isArsCurrency && !loading" class="price">
          U$D {{ (isBuying ? getCryptoPrice(0) : getCryptoPrice(1)) | number : '0.3-3' }}
        </p>
      </div>

      <!-- <p
        class="dailyChange"
        [class.green]="variation > 0"
        [class.red]="variation < 0"
        *ngIf="(variation < 0 || variation === 0 || variation > 0) && cryptoSymbol !== 'USDT'"
      >
        {{ variation > 0 ? '+' : '' }}{{ variation | number : '.0-3' }}%
      </p> -->
    </div>
    <form class="exchange-form">
      <div class="form-container">
        <div class="input-section">
          <div class="input-item">
            <div class="input-label">
              <label>Cantidad {{ cryptoSymbol }}</label>
            </div>
            <div class="input-container">
              <input
                type="text"
                placeholder="0,00"
                [mask]="!cryptoService.isStableCoin(cryptoSymbol) ? 'separator.5' : 'separator.3'"
                thousandSeparator="."
                [formControl]="operateQuantity"
                (blur)="($event.preventDefault)"
                (keyup)="syncAmounts(false)"
                [class.isBuying]="isBuying"
              />
            </div>
            <p *ngIf="!isBuying" class="available-crypto">
              Fondos disponibles:
              {{
                (authService.hasValidatedDNIS() ? +getCurrentBalance() : 0)
                  | formatCoinAmount : cryptoSymbol
              }}
              {{ cryptoSymbol }}
            </p>
            <div class="percentage-buttons" *ngIf="isBuying">
              <button
                (click)="setMaxSrcCoinBalance(25)"
                [class.selected]="
                  isArsCurrency ? selectedPercentage === '25b' : selectedPercentage === '25bUSD'
                "
              >
                25%
              </button>
              <button
                (click)="setMaxSrcCoinBalance(50)"
                [class.selected]="
                  isArsCurrency ? selectedPercentage === '50b' : selectedPercentage === '50bUSD'
                "
              >
                50%
              </button>
              <button
                (click)="setMaxSrcCoinBalance(75)"
                [class.selected]="
                  isArsCurrency ? selectedPercentage === '75b' : selectedPercentage === '75bUSD'
                "
              >
                75%
              </button>
              <button
                (click)="setMaxSrcCoinBalance(100)"
                [class.selected]="
                  isArsCurrency ? selectedPercentage === '100b' : selectedPercentage === '100bUSD'
                "
              >
                100%
              </button>
            </div>
          </div>
          <div class="input-item" *ngIf="isArsCurrency">
            <div class="fiat-selector">
              <div class="circle" [class.isArsCurrency]="isArsCurrency"></div>
              <div
                class="pill"
                [ngClass]="{ active: isArsCurrency }"
                (click)="changeCurrentCurrency(CURRENCY_FILTER.ARS)"
              >
                <p [class.active]="isArsCurrency">AR$</p>
              </div>
              <div
                class="pill"
                [ngClass]="{ active: !isArsCurrency }"
                (click)="changeCurrentCurrency(CURRENCY_FILTER.USD)"
              >
                <p [class.disabled]="isBlockedByCoin()">U$D</p>
              </div>
            </div>
            <div class="input-container">
              <input
                type="text"
                placeholder="0,00"
                [mask]="isArsCurrency ? 'separator.2' : 'separator.3'"
                thousandSeparator="."
                [formControl]="amountArs"
                (keyup)="syncAmounts(true)"
                [class.isBuying]="!isBuying"
              />
            </div>
            <p *ngIf="isBuying" class="available-ars">
              Fondos disponibles: {{ getAvailableFund() | currency : 'AR$' }}
            </p>
            <div class="percentage-buttons" *ngIf="!isBuying">
              <button
                (click)="setMaxSrcCoinBalance(25)"
                [class.selected]="selectedPercentage === '25s'"
              >
                25%
              </button>
              <button
                (click)="setMaxSrcCoinBalance(50)"
                [class.selected]="selectedPercentage === '50s'"
              >
                50%
              </button>
              <button
                (click)="setMaxSrcCoinBalance(75)"
                [class.selected]="selectedPercentage === '75s'"
              >
                75%
              </button>
              <button
                (click)="setMaxSrcCoinBalance(100)"
                [class.selected]="selectedPercentage === '100s'"
              >
                100%
              </button>
            </div>
          </div>

          <div class="input-item" *ngIf="!isArsCurrency">
            <div class="fiat-selector">
              <div class="circle" [class.isArsCurrency]="isArsCurrency"></div>
              <div
                class="pill"
                [ngClass]="{ active: isArsCurrency }"
                (click)="changeCurrentCurrency(CURRENCY_FILTER.ARS)"
              >
                <p [class.disabled]="isBlockedByCoin()">AR$</p>
              </div>
              <div
                class="pill"
                [ngClass]="{ active: !isArsCurrency }"
                (click)="changeCurrentCurrency(CURRENCY_FILTER.USD)"
              >
                <p [class.active]="!isArsCurrency">U$D</p>
              </div>
            </div>
            <div class="input-container">
              <input
                type="text"
                placeholder="0,000"
                mask="separator.3"
                thousandSeparator="."
                [formControl]="amountArs"
                (keyup)="syncAmounts(true)"
                [style]="!isBuying ? 'margin-bottom: 8px' : ''"
              />
            </div>

            <p *ngIf="isBuying" class="available-ars">
              Fondos disponibles: U$D {{ getAvailableFund() | number : '0.1-3' }}
            </p>
            <div class="percentage-buttons" *ngIf="!isBuying">
              <button
                (click)="setMaxSrcCoinBalance(25)"
                [class.selected]="selectedPercentage === '25s'"
              >
                25%
              </button>
              <button
                (click)="setMaxSrcCoinBalance(50)"
                [class.selected]="selectedPercentage === '50s'"
              >
                50%
              </button>
              <button
                (click)="setMaxSrcCoinBalance(75)"
                [class.selected]="selectedPercentage === '75s'"
              >
                75%
              </button>
              <button
                (click)="setMaxSrcCoinBalance(100)"
                [class.selected]="selectedPercentage === '100s'"
              >
                100%
              </button>
            </div>
          </div>
        </div>

        <div class="divider"></div>

        <div class="price-section">
          <div class="price-contain">
            <p class="price-label">{{ isBuying ? 'Costo total' : 'Total a recibir' }}</p>
            <!-- <p class="discount-price-label" *ngIf="maxDiscountApplicable">
              {{ getCoinTicker() }} {{ finalAmount }}
              {{ isBuying ? '-' : '+' }}
              {{ getCoinTicker() }}
              {{
                isArsCurrency
                  ? (getDiffrenceByDiscount() | number: '0.2-2')
                  : (getDiffrenceByDiscount() | number: '0.3-3')
              }}
              ({{ maxDiscountApplicable * 100 }}%)
            </p> -->
            <p class="price" *ngIf="!isArsCurrency">
              {{
                maxDiscountApplicable
                  ? getFinalAmountWithDiscount()
                  : (finalAmount | number : '0.2-2')
              }}
              U$D
            </p>
            <p class="price" *ngIf="isArsCurrency">
              {{
                maxDiscountApplicable
                  ? getFinalAmountWithDiscount()
                  : (finalAmount | number : '0.2-2')
              }}
              AR$
            </p>
          </div>
        </div>
      </div>
      <div *ngIf="!creatingOrder && !loading; else trxProcessing">
        <button
          *ngIf="isBuying"
          class="td-btn primary"
          [disabled]="creatingOrder || isBuyingDisabled"
          (click)="handleOrder()"
        >
          {{
            isBuyingDisabled
              ? 'Compra con ' + (isArsCurrency ? 'AR$' : 'U$D') + ' deshabilitada'
              : 'Comprar'
          }}
        </button>
        <button
          *ngIf="!isBuying"
          class="td-btn primary"
          [disabled]="creatingOrder || isSellingDisabled"
          (click)="handleOrder()"
        >
          {{
            isSellingDisabled
              ? 'Venta con ' + (isArsCurrency ? 'AR$' : 'U$D') + ' deshabilitada'
              : 'Vender'
          }}
        </button>
      </div>
      <ng-template #trxProcessing>
        <div class="loading">
          <div class="circle-loader">
            <div class="checkmark draw"></div>
          </div>
        </div>
      </ng-template>
    </form>
  </div>
</div>
